export enum LinkOperation {
View,
Stapled,
}
